import { GHG_REPORT_COVER_PDF_CSS } from "./ghgReportCoverPdfCss.generated";

const GHG_REPORT_PDF_PAGE_BREAKS = `
  @page {
    size: A4 portrait;
    /* Reserve a header band for the left and right logos. */
    margin: 22mm 0 15mm 0;
  }
    html,
body {
  margin: 0;
  padding: 0;
}

[data-pdf-cover="true"] {
  position: relative !important;
  display: block !important;
  width: 210mm !important;
  height: 297mm !important;
  min-height: 297mm !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: hidden !important;
  box-sizing: border-box !important;
  break-after: page !important;
  page-break-after: always !important;
}

[data-pdf-cover="true"] [class*="cover_bg"] {
  position: absolute !important;
  inset: 0 !important;
  width: 100% !important;
  height: 100% !important;
  max-width: none !important;
  object-fit: cover !important;
  object-position: center !important;
  z-index: 0 !important;
}

[data-pdf-cover="true"] [class*="cover_overlay"] {
  position: absolute !important;
  inset: 0 !important;
  z-index: 1 !important;
}

[data-pdf-cover="true"] [class*="cover_content"],
[data-pdf-cover="true"] [class*="cover_words"] {
  position: absolute !important;
  z-index: 2 !important;
}

[data-pdf-toc="true"] {
  display: block !important;
  width: 100% !important;
  min-height: 257mm !important;
  box-sizing: border-box !important;
  break-before: page !important;
  page-break-before: always !important;
  break-after: page !important;
  page-break-after: always !important;
}

  body > div {
    padding: 0 !important;
    margin: 0 !important;
  }

  [class*="cover_page"],
  [class*="toc_page"],
  [class*="exec_page"],
  [class*="general_page"],
  [class*="report_page"] {
    min-height: auto !important;
    margin-bottom: 0 !important;
    page-break-after: auto !important;
    break-after: auto !important; 
    page-break-inside: auto !important;
    break-inside: auto !important;
    page-break-before: auto !important;
    break-before: auto !important;
  }

  [data-ghg-report-edit-ui] {
    display: none !important;
  }




  [data-pdf-report-banner="true"] {
    position: relative !important;
    width: 100% !important;
    height: 92mm !important;
    overflow: hidden !important;
    padding: 0 !important;
  }

  [data-pdf-report-banner="true"]::after {
    content: "" !important;
    position: absolute !important;
    inset: 0 !important;
    z-index: 1 !important;
    background: rgba(0, 0, 0, 0.34) !important;
  }

  [data-pdf-report-banner-image="true"] {
    position: absolute !important;
    inset: 0 !important;
    z-index: 0 !important;
    display: block !important;
    width: 100% !important;
    height: 100% !important;
    max-width: none !important;
    object-fit: cover !important;
    object-position: center center !important;
  }

  [data-pdf-report-banner-title="true"] h1 {
    font-family: "Inter", Arial, sans-serif !important;
    font-size: 42px !important;
    line-height: 1.05 !important;
    font-weight: 700 !important;
    font-style: normal !important;
    text-decoration: none !important;
    letter-spacing: normal !important;
    margin: 0 !important;
  }

  [data-pdf-report-banner-title="true"] {
    position: absolute !important;
    left: 12mm !important;
    right: 12mm !important;
    bottom: 16mm !important;
    z-index: 2 !important;
    color: #fff !important;
  }

  [data-pdf-report-banner-title="true"] > div {
    display: flex !important;
    align-items: center !important;
    gap: 2mm !important;
    width: 48% !important;
    margin-top: 3mm !important;
  }

  [data-pdf-report-banner-title="true"] > div > span {
    display: block !important;
    height: 1.5mm !important;
  }

  [data-pdf-report-banner-title="true"] > div > span:nth-child(1) {
    flex: 1 !important;
    background: #f58220 !important;
  }

  [data-pdf-report-banner-title="true"] > div > span:nth-child(2) {
    flex: 3 !important;
    background: #5a9b60 !important;
  }

  [data-pdf-report-banner-title="true"] > div > span:nth-child(3) {
    flex: 7 !important;
    background: #1c486b !important;
  }

  /* Backend supplies 10mm; add 5mm to report/TOC pages for 15mm side spacing. */
  [data-pdf-cover="true"] ~ *,
  [data-ghg-pdf-cover-wrapper="true"] ~ * {
    margin-left: 5mm !important;
    margin-right: 5mm !important;
  }

  /* The report image banner is full width; do not apply content side gutters. */
  [data-pdf-cover="true"] ~ [data-pdf-report-banner="true"],
  [data-ghg-pdf-cover-wrapper="true"] ~ [data-pdf-report-banner="true"] {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  /* Cover page — full-bleed rules live in getGhgReportFirstPagePdfCss() (appended last). */

  [class*="cover_body"] {
    flex: 1 !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
  }

  /* Force new page only for intro sections — NOT every report_page block */
  [class*="toc_page"],
  [class*="exec_page"],
  [class*="general_page"] {
    page-break-before: always !important;
    break-before: page !important;
    margin-top: 1px !important;
  }

  [class*="cover_title"] {
    text-decoration: none !important;
    text-shadow: none !important;
  }

  [class*="cover_info_label"] {
    display: block !important;
    letter-spacing: 0.04em !important;
    word-spacing: normal !important;
  }

  [class*="cover_info_value"] {
    display: block !important;
    text-shadow: none !important;
  }

  [class*="cover_info_grid"] {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
  }

  [class*="cover_info_item"] {
    display: flex !important;
    flex-direction: column !important;
  }

  /* Executive Summary intro page — match Figma typography in PDF */
  [class*="exec_page"] {
    font-family: "Inter", Arial, sans-serif !important;
  }

  [class*="exec_main_title"] {
    font-family: "Inter", Arial, sans-serif !important;
    font-size: 2rem !important;
    font-weight: 700 !important;
    color: #000000 !important;
    line-height: 1.25 !important;
    text-decoration: none !important;
    text-align: left !important;
    margin: 0 0 1.75rem !important;
  }

  [class*="exec_info_box"] {
    font-family: "Inter", Arial, sans-serif !important;
    background-color: #498151 !important;
  }

  [class*="exec_info_label"],
  [class*="exec_info_value"] {
    font-family: "Inter", Arial, sans-serif !important;
    font-size: 1rem !important;
    font-weight: 400 !important;
    line-height: 1.5 !important;
    color: #ffffff !important;
  }

  div[class*="page_break"],
  div[class*="pageBreak"],
  div[class*="page-break"] {
    display: none !important;
    height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  /* Keep the heading with the table start, but allow long rows to continue. */
  [data-pdf-keep-heading-table="true"],
  [data-pdf-keep-heading-table="true"] .MuiTableContainer-root,
  [data-pdf-keep-heading-table="true"] table,
  [data-pdf-keep-heading-table="true"] tbody {
    page-break-inside: auto !important;
    break-inside: auto !important;
  }

  [data-pdf-keep-heading-table="true"] > p {
    margin-bottom: 3mm !important;
    page-break-after: avoid !important;
    break-after: avoid-page !important;
  }

  [data-pdf-keep-heading-table="true"] thead {
    display: table-header-group !important;
  }

  [data-pdf-keep-heading-table="true"] tr {
    page-break-inside: avoid !important;
    break-inside: avoid-page !important;
  }
  /* Keep each metric heading and its table together on one PDF page. */
  [class*="environment_heading"],
  [class*="table_section_heading"],
  [class*="scope_heading"] {
    page-break-after: avoid !important;
    break-after: avoid-page !important;
  }

  [class*="direct_emission_div"],
  .MuiTableContainer-root,
  table {
    page-break-inside: avoid !important;
    break-inside: avoid-page !important;
  }

  table tr,
  table th,
  table td {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }
  [data-pdf-company-details="true"] { display: none !important; }
  [data-pdf-toc="true"] {
    position: relative !important; display: block !important; width: 100% !important;
    min-height: 256mm !important; padding: 15mm 10mm 14mm !important;
    overflow: hidden !important; box-sizing: border-box !important;
    background: linear-gradient(135deg, #fff, #f8f9f6) !important;
    font-family: Inter, Arial, sans-serif !important;
    break-before: page !important; break-after: page !important;
  }
  [data-pdf-toc="true"] [class*="toc_top_rule"] { display: none !important; }
  [data-pdf-toc="true"] [class*="toc_brand_header"] { display: none !important; }
  [data-pdf-toc="true"] [class*="toc_brand_header"] img {
    display: block !important; width: auto !important; max-width: 30mm !important; height: 8mm !important; object-fit: contain !important;
  }
  [data-pdf-toc="true"] [class*="toc_heading_block"] { margin: 9mm 0 6mm !important; }
  [data-pdf-toc="true"] [class*="toc_heading_block"] h2 { margin: 0 !important; color: #1c486b !important; font-size: 7mm !important; }
  [data-pdf-toc="true"] [class*="toc_heading_block"] > div { display: flex !important; gap: 2mm !important; width: 58mm !important; height: 1.4mm !important; margin-top: 3mm !important; }
  [data-pdf-toc="true"] [class*="toc_heading_block"] span:first-child { width: 12mm !important; background: #f58220 !important; }
  [data-pdf-toc="true"] [class*="toc_heading_block"] span:last-child { flex: 1 !important; background: #1c486b !important; }
  [data-pdf-toc="true"] [data-pdf-toc-sections="true"] { position: relative !important; z-index: 2 !important; }
  [data-pdf-toc="true"] [data-pdf-toc-section="true"] { margin-bottom: 5mm !important; }
  [data-pdf-toc="true"] [data-pdf-toc-section-bar="true"] {
    display: grid !important; grid-template-columns: minmax(0, 1fr) 18mm !important;
    align-items: center !important; column-gap: 5mm !important;
    min-height: 9mm !important; padding: 2mm 3mm !important; color: #111 !important; background: #dedede !important; font-size: 3.8mm !important;
  }
  [data-pdf-toc="true"] [class*="toc_section_green"] { color: #fff !important; background: #4b895f !important; }
  [data-pdf-toc="true"] [class*="toc_section_orange"] { color: #fff !important; background: #f5820b !important; }
  [data-pdf-toc="true"] [class*="toc_section_blue"] { color: #fff !important; background: #1f4f72 !important; }
  [data-pdf-toc="true"] [data-pdf-toc-entry-group="true"] { margin-top: 2mm !important; }
  [data-pdf-toc="true"] [data-pdf-toc-entry="true"] {
    display: grid !important; grid-template-columns: minmax(0, 1fr) 18mm !important; gap: 5mm !important;
    padding: .7mm 3mm .7mm 5mm !important; color: #1d2730 !important; font-size: 3.2mm !important; line-height: 1.3 !important;
  }
  [data-pdf-toc="true"] [data-pdf-toc-child-entry="true"] { padding-left: 10mm !important; color: #65717e !important; }
  [data-pdf-toc="true"] [data-pdf-toc-section-bar="true"] > :last-child,
  [data-pdf-toc="true"] [data-pdf-toc-entry="true"] > :last-child {
    width: 100% !important; justify-self: end !important; text-align: right !important;
    white-space: nowrap !important; font-variant-numeric: tabular-nums !important;
  }
  [data-pdf-toc="true"] [class*="toc_decorative_art"] { display: none !important; }
  [data-pdf-toc="true"] [class*="toc_lime_green_shape"],
  [data-pdf-toc="true"] [class*="toc_dark_green_shape"] {
    position: absolute !important; display: block !important; max-width: none !important; object-fit: fill !important;
  }
  [data-pdf-toc="true"] [class*="toc_lime_green_shape"] {
    right: 0 !important; bottom: 0 !important; z-index: 1 !important; width: 76% !important; height: 100% !important;
  }
  [data-pdf-toc="true"] [class*="toc_dark_green_shape"] {
    left: 0 !important; bottom: 0 !important; z-index: 2 !important; width: 52% !important; height: 66% !important;
  }
  [data-pdf-toc="true"] [class*="toc_footer"] { display: none !important; }
  [data-pdf-toc="true"] [class*="toc_footer"] img { width: auto !important; height: 6mm !important; margin-left: 2mm !important; }
  [data-pdf-toc="true"] [class*="toc_footer"] strong { margin-left: auto !important; font-size: 3.6mm !important; }`;

const GHG_REPORT_LEGACY_PDF_CSS = `

        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
        
        * {
          box-sizing: border-box;
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }
        
        body {
          font-family: Inter, Arial, sans-serif;
          margin: 0;
          padding: 0;
          color: #000;
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }

        .table {
          width: 60%;
          margin-top: 1rem;
        }

        .logo {
          width: auto;
          height: 80px;
          margin-bottom: 1rem;
        }

        .page_break {
          display: block;
          height: 0;
          page-break-before: always !important;
          break-before: page !important;
          margin: 0;
          padding: 0;
        }

        .pageBreak {
          display: block;
          height: 0;
          page-break-before: always !important;
          break-before: page !important;
          margin: 0;
          padding: 0;
        }

        /* Support for CSS module hashed class names - page breaks */
        div[class*="page_break"],
        div[class*="pageBreak"],
        div[class*="page-break"] {
          display: block !important;
          height: 0 !important;
          page-break-before: always !important;
          break-before: page !important;
          margin: 0 !important;
          padding: 0 !important;
        }

        /* Also support inline style page breaks */
        [style*="page-break-before: always"],
        [style*="pageBreakBefore: always"],
        [style*="break-before: page"],
        [style*="breakBefore: page"] {
          page-break-before: always !important;
          break-before: page !important;
        }

        .table_heading {
          font-family: Inter;
          font-size: 14px;
          font-weight: 600;
          line-height: 22px;
          letter-spacing: 0.5px;
        }

        .table_value {
          font-family: Inter;
          font-size: 14px;
          font-weight: 400;
          line-height: 22px;
          letter-spacing: 0.5px;
        }

        .heading {
          font-family: Inter;
          font-size: 16px;
          font-weight: 700;
          line-height: 24px;
          letter-spacing: 0.5px;
        }

        .heading_bold {
          font-weight: 700 !important;
        }

        /* Support for CSS module hashed class names - heading_bold */
        [class*="heading_bold"] {
          font-weight: 700 !important;
        }

        .sub_heading {
          font-family: Inter;
          font-size: 14px;
          font-weight: 600;
          line-height: 22px;
          letter-spacing: 0.5px;
          margin-left: 1rem;
        }

        .sub_heading_graph {
          font-family: Inter;
          font-size: 16px;
          font-weight: 600;
          line-height: 25.6px;
          color: rgba(102, 102, 102, 0.8);
        }

        .direct_emission_div {
          background-color: #fcfcfc;
          padding: 1rem;
          border-radius: 12px;
          margin-top: 1rem;
        }

        .scope_emission_div {
          margin-top: 2rem;
        }

        .vehicle_div {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .sub_sub_heading {
          font-family: Inter;
          font-size: 14px;
          font-weight: 600;
          line-height: 22px;
          letter-spacing: 0.5px;
          color: rgba(0, 0, 0, 1);
          margin-top: 2rem;
        }

        .sub_sub_heading.heading_bold,
        [class*="sub_sub_heading"][class*="heading_bold"] {
          font-weight: 700 !important;
        }

        .sub_main_heading {
          font-family: Inter;
          font-size: 14px;
          font-weight: 600;
          line-height: 22px;
          letter-spacing: 0.5px;
          font-style: italic;
        }

        .company_footer {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 0.5rem;
          flex-direction: column;
          margin-top: 2rem;
        }

        .summary_heading {
          font-family: Inter;
          font-weight: 600;
          opacity: 90%;
        }

        .summary_heading.heading_bold,
        [class*="summary_heading"][class*="heading_bold"] {
          font-weight: 700 !important;
        }

        .summary_subheading {
          font-family: Inter;
          font-size: 14px;
          opacity: 70%;
          margin-top: -0.5rem;
        }

        .summary_text {
          font-family: Inter;
          font-size: 12px;
          opacity: 70%;
          line-height: 1.25rem;
          padding: 0 1rem;
          margin-bottom: 1rem;
        }

        .report_metadata_table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 1rem;
        }

        .report_metadata_table tr {
          border-bottom: none;
        }

        .report_metadata_table td {
          padding: 0.25rem 0;
          text-align: left;
        }

        .summary_chart_container {
          display: flex !important;
          flex-direction: row !important;
          gap: 2rem;
          margin-top: 1.5rem;
          align-items: flex-start;
          width: 100%;
          justify-content: flex-start;
        }

        .summary_table_wrapper {
          width: 35%;
          max-width: 400px;
          min-width: 300px;
          flex-shrink: 0;
        }

        .summary_table {
          width: 100%;
          border-collapse: collapse;
          border: 1px solid #ddd;
          background-color: #ffffff;
          table-layout: auto;
        }

        .summary_table thead {
          background-color: #1C486B;
        }

        .summary_table_header {
          font-family: Inter;
          font-size: 14px;
          font-weight: 600;
          padding: 0.5rem;
          border: 1px solid #ddd;
          background-color: #1C486B;
          color: #ffffff;
          text-align: left;
        }

        .summary_table_header:last-child {
          text-align: right;
        }

        .summary_table_cell {
          font-family: Inter;
          font-size: 14px;
          padding: 0.5rem;
          border: 1px solid #ddd;
          text-align: left;
          background-color: #ffffff;
        }

        .summary_table_cell[style*="text-align: right"] {
          text-align: right;
        }

        .summary_table tbody tr {
          background-color: #ffffff;
        }

        /* Support for CSS module hashed class names using attribute selectors */
        table[class*="summary_table"] {
          width: 100%;
          border-collapse: collapse;
          border: 1px solid #ddd;
          background-color: #ffffff;
          table-layout: auto;
        }

        table[class*="summary_table"] thead {
          background-color: #1C486B;
        }

        table[class*="summary_table"] th[class*="summary_table_header"] {
          font-family: Inter;
          font-size: 14px;
          font-weight: 600;
          padding: 0.5rem;
          border: 1px solid #ddd;
          background-color: #1C486B;
          color: #ffffff;
          text-align: left;
        }

        table[class*="summary_table"] th[class*="summary_table_header"]:last-child {
          text-align: right;
        }

        table[class*="summary_table"] td[class*="summary_table_cell"] {
          font-family: Inter;
          font-size: 14px;
          padding: 0.5rem;
          border: 1px solid #ddd;
          text-align: left;
          background-color: #ffffff;
        }

        table[class*="summary_table"] td[class*="summary_table_cell"][style*="text-align: right"] {
          text-align: right;
        }

        table[class*="summary_table"] tbody tr {
          background-color: #ffffff;
        }

        .pie_chart_wrapper {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;
          min-width: 300px;
        }

        .emission_breakdown_table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 1rem;
          background-color: #ffffff;
          border: 1px solid #ddd;
          table-layout: auto;
        }

        .emission_breakdown_table th:first-child,
        .emission_breakdown_table td:first-child {
          width: 15%;
        }

        .emission_breakdown_table th:nth-child(2),
        .emission_breakdown_table td:nth-child(2) {
          width: 60%;
        }

        .emission_breakdown_table th:nth-child(3),
        .emission_breakdown_table td:nth-child(3) {
          width: 25%;
          text-align: right;
        }

        .emission_breakdown_table thead {
          background-color: #1C486B;
        }

        .emission_table_header {
          font-family: Inter;
          font-size: 14px;
          font-weight: 600;
          padding: 0.75rem;
          border: 1px solid #ddd;
          background-color: #1C486B;
          color: #ffffff;
          text-align: left;
        }

        .emission_table_header:last-child {
          text-align: right;
        }

        .emission_breakdown_table tbody {
          background-color: #ffffff;
        }

        .emission_table_cell {
          font-family: Inter;
          font-size: 14px;
          padding: 0.75rem;
          border: 1px solid #ddd;
          text-align: left;
          vertical-align: middle;
          background-color: #ffffff;
        }

        .emission_breakdown_table tbody tr {
          background-color: #ffffff;
        }

        /* Additional styles for emission breakdown table using summary_table class */
        /* These styles ensure the table at line 1188 renders correctly in PDF */
        table.summary_table {
          width: 100%;
          border-collapse: collapse;
          border: 1px solid #ddd;
          background-color: #ffffff;
          table-layout: auto;
          margin-top: 1.5rem;
        }

        table.summary_table thead {
          background-color: #1C486B;
        }

        table.summary_table th.emission_table_header {
          font-family: Inter;
          font-size: 14px;
          font-weight: 600;
          padding: 0.75rem;
          border: 1px solid #ddd;
          background-color: #1C486B;
          color: #ffffff;
          text-align: left;
        }

        table.summary_table th.emission_table_header:last-child {
          text-align: right;
        }

        table.summary_table td.emission_table_cell {
          font-family: Inter;
          font-size: 14px;
          padding: 0.75rem;
          border: 1px solid #ddd;
          text-align: left;
          vertical-align: middle;
          background-color: #ffffff;
        }

        table.summary_table td.emission_table_cell[style*="text-align: right"] {
          text-align: right;
        }

        table.summary_table tbody tr {
          background-color: #ffffff;
        }

        /* Support for CSS module hashed class names using attribute selectors */
        table[class*="summary_table"] {
          width: 100%;
          border-collapse: collapse;
          border: 1px solid #ddd;
          background-color: #ffffff;
          table-layout: auto;
          margin-top: 1.5rem;
        }

        table[class*="summary_table"] thead {
          background-color: #1C486B;
        }

        table[class*="summary_table"] th[class*="emission_table_header"] {
          font-family: Inter;
          font-size: 14px;
          font-weight: 600;
          padding: 0.75rem;
          border: 1px solid #ddd;
          background-color: #1C486B;
          color: #ffffff;
          text-align: left;
        }

        table[class*="summary_table"] th[class*="emission_table_header"]:last-child {
          text-align: right;
        }

        table[class*="summary_table"] td[class*="emission_table_cell"] {
          font-family: Inter;
          font-size: 14px;
          padding: 0.75rem;
          border: 1px solid #ddd;
          text-align: left;
          vertical-align: middle;
          background-color: #ffffff;
        }

        table[class*="summary_table"] tbody tr {
          background-color: #ffffff;
        }

        /* Additional styles for proper rendering */
        table {
          border-collapse: collapse;
          width: 100%;
        }

        ul {
          margin-left: 1.5rem;
          padding: 0;
        }

        li {
          margin-bottom: 0.5rem;
        }

        h1:not([class*="cover_title"]):not([class*="exec_main_title"]) {
          font-family: "Inter", Arial, sans-serif;
          font-size: 24px;
          font-weight: 700;
          text-decoration: underline;
          margin-bottom: 1rem;
          margin-top: 0;
          text-align: left;
        }

        img {
          max-width: 100%;
          height: auto;
        }

        /* Material-UI Table overrides for PDF */
        .MuiTableContainer-root {
          margin-top: 1rem;
          background-color: #ffffff;
        }

        .MuiTable-root {
          width: 100%;
          border-collapse: collapse;
        }

        .MuiTableHead-root {
          background-color: #1C486B;
        }

        .MuiTableCell-head {
          background-color: #1C486B !important;
          color: #ffffff !important;
          font-family: Inter;
          font-size: 14px;
          font-weight: 600;
          padding: 8px;
          border: 1px solid #ddd;
        }

        .MuiTableCell-body {
          background-color: #ffffff;
          font-family: Inter;
          font-size: 14px;
          padding: 8px;
          border: 1px solid #ddd;
        }

        .MuiTableRow-root {
          background-color: #ffffff;
        }

        /* Additional page break support - ensure they work in PDF */
        div.page-break,
        div[class*="page-break"] {
          display: block !important;
          height: 0 !important;
          width: 100% !important;
          page-break-before: always !important;
          break-before: page !important;
          margin: 0 !important;
          padding: 0 !important;
          border: none !important;
        }
`;

/** Must match backend puppeteer page.pdf margins in /generate-pdf */
export const GHG_PDF_BACKEND_MARGINS = {
  top: "21mm",
  right: "10mm",
  bottom: "20mm",
  left: "10mm",
};

/**
 * First-page-only PDF CSS — bleeds cover into backend margins (frontend-only fix).
 * Uses negative margin only (no top/left position) + object-fit/background cover.
 */
export function getGhgReportFirstPagePdfCss() {
  const { top, bottom, left } = GHG_PDF_BACKEND_MARGINS;

  return `
  @page:first {
    size: A4 portrait;
    margin: 0 !important;
  }

  html,
  body {
    margin: 0 !important;
    padding: 0 !important;
    overflow: visible !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  [data-ghg-pdf-cover-wrapper="true"] {
    display: block !important;
    box-sizing: border-box !important;
    position: relative !important;
    width: 210mm !important;
    height: 297mm !important;
    min-width: 210mm !important;
    min-height: 297mm !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden !important;
    border-radius: 0 !important;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    page-break-after: always !important;
    break-after: page !important;
  }

  [data-ghg-pdf-cover-wrapper="true"] [data-ghg-pdf-cover-page="true"],
  [data-ghg-pdf-cover-wrapper="true"] [class*="cover_page"] {
    display: block !important;
    box-sizing: border-box !important;
    width: 100% !important;
    height: 100% !important;
    min-height: 297mm !important;
    margin: 0 !important;
    padding: 0 !important;
    border-radius: 0 !important;
    overflow: hidden !important;
    position: relative !important;
    background-size: cover !important;
    background-position: center center !important;
    background-repeat: no-repeat !important;

      position: relative !important;
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
  overflow: hidden !important;
  color: #fff !important;
  background: #12202b !important;
  break-after: page !important;
  page-break-after: always !important;
  }

  [data-ghg-pdf-cover-wrapper="true"] [class*="cover_bg"] {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    min-width: 100% !important;
    min-height: 100% !important;
    max-width: none !important;
    margin: 0 !important;
    padding: 0 !important;
    object-fit: cover !important;
    object-position: center center !important;
    z-index: 0 !important;
    display: block !important;
      inset: 0 !important;
  }

  [data-ghg-pdf-cover-wrapper="true"] [class*="cover_overlay"] {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    z-index: 1 !important;
    pointer-events: none !important;
    insert: 0 !important;
      background:
    linear-gradient(
      180deg,
      rgba(5, 15, 20, 0.05) 5%,
      rgba(7, 20, 29, 0.3) 42%,
      rgba(5, 17, 28, 0.92) 100%
    );
  }

  [data-ghg-pdf-cover-wrapper="true"] [class*="cover_content"] {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    z-index: 2 !important;
    box-sizing: border-box !important;
    width: 100% !important;
    height: 100% !important;
    margin: 0 !important;
    padding: calc(${top} + 48px) calc(${left} + 56px) calc(${bottom} + 48px) calc(${left} + 56px) !important;
    display: flex !important;
    flex-direction: column !important;
    border-radius: 0 !important;
  }

  [data-ghg-pdf-cover-wrapper="true"] [class*="cover_body"] {
    flex: 1 !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
  }

  [data-ghg-pdf-cover-wrapper="true"] [class*="cover_title"] {
    text-decoration: none !important;
    text-shadow: none !important;
  }
    [data-pdf-cover="true"] {
  position: relative !important;
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: hidden !important;
  box-sizing: border-box !important;
  break-after: page !important;
  page-break-after: always !important;
  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
}

[data-pdf-cover-image="true"] {
  position: absolute !important;
  inset: 0 !important;
  z-index: 1 !important;
  display: block !important;
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  max-width: none !important;
  object-fit: cover !important;
  object-position: center center !important;
}

[data-pdf-cover="true"]::after {
  content: "" !important;
  position: absolute !important;
  inset: 0 !important;
  z-index: 5 !important;
  background: rgba(5, 18, 30, 0.64) !important;
}


[data-pdf-cover-header="true"] {
  position: absolute !important;
  top: 4mm !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 20 !important;
  display: flex !important;
  justify-content: space-between !important;
  align-items: flex-start !important;
  height: 8mm !important;
  padding: 0 10mm 0 9mm !important;
  box-sizing: border-box !important;
  background: transparent !important;
}

[data-pdf-cover-header="true"] img {
  display: block !important;
  width: auto !important;
  max-width: 38mm !important;
  height: 11mm !important;
  object-fit: contain !important;
}

[data-pdf-cover-header="true"] strong {
  color: #fff !important;
  font-size: 4mm !important;
}

[data-pdf-cover-footer="true"] { 
  position: absolute !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  z-index: 30 !important; 
  display: flex !important;
  align-items: center !important;
  height: 12mm !important;
  padding: 0 11mm !important;
  box-sizing: border-box !important;
  color: #fff !important;
  background: linear-gradient(
    90deg,
    #f8ad58 0%,
    #a9823f 25%,
    #46532b 52%,
    #123f3b 72%,
    #1f4f72 100%
  ) !important;
  font-family: Inter, Arial, sans-serif !important;
  font-size: 2.5mm !important;
}

[data-pdf-cover-footer="true"] img {  
  display: block !important;
  width: auto !important;
  height: 6mm !important;
  margin-left: 2mm !important;
  object-fit: contain !important;
}

[data-pdf-cover-footer="true"] strong {
  margin-left: auto !important;
  font-size: 3.5mm !important;
  font-weight: 500 !important;
}

[data-pdf-cover-text="true"] {
  position: absolute !important;
  top: auto !important;
  bottom: 28mm !important;
  left: 12mm !important;
  right: 12mm !important;
  z-index: 20 !important;
  display: block !important;
  color: #fff !important;
  font-family: Inter, Arial, sans-serif !important;
}

[data-pdf-cover-text="true"] h1 {
  margin: 0 !important;
  color: #fff !important;
  font-size: 14mm !important;
  font-weight: 700 !important;
  line-height: 1.1 !important;
  text-decoration: none !important;
  border-bottom: none !important;
}

[data-pdf-cover-accent="true"] {
  display: flex !important;
  width: 70mm !important;
  height: 2mm !important;
  margin-top: 5mm !important;
}

[data-pdf-cover-accent="true"] span:nth-child(1) {
  width: 23mm !important;
  background: #56a36c !important;
}

[data-pdf-cover-accent="true"] span:nth-child(2) {
  width: 23mm !important;
  background: #f58220 !important;
}

[data-pdf-cover-accent="true"] span:nth-child(3) {
  flex: 1 !important;
  background: #23668d !important;
}

[data-pdf-cover-divider="true"] {
  height: 0.35mm !important;
  margin-top: 18mm !important;
  background: rgba(255, 255, 255, 0.28) !important;
}

[data-pdf-cover-details="true"] {
  display: grid !important;
  grid-template-columns: 1fr 1fr !important;
  gap: 12mm 18mm !important;
  margin-top: 17mm !important;
}

[data-pdf-cover-details="true"] > div {
  display: flex !important;
  flex-direction: column !important;
  gap: 3mm !important;
}

[data-pdf-cover-details="true"] span {
  color: rgba(255, 255, 255, 0.68) !important;
  font-size: 4mm !important;
  font-weight: 400 !important;
}

[data-pdf-cover-details="true"] strong {
  color: #fff !important;
  font-size: 4.2mm !important;
  font-weight: 700 !important;
}
`;
}

const GHG_REPORT_PREVIEW_PALETTE_PDF_CSS = `
  /* Bold only real headings; answer/value content stays regular. */
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  [class*="_heading_"],
  [class*="underline_heading"],
  [class*="summary_heading"],
  [class*="environment_heading"],
  [class*="environment_subheading"],
  [class*="scope_heading"],
  [class*="table_section_heading"],
  [class*="social_heading"],
  [class*="social_subheading"],
  [class*="sub_heading_graph"],
  [class*="governance_heading"],
  [class*="governance_subheading"],
  [class*="conclusionTitle"],
  [class*="conclusionSubheading"],
  [class*="sub_main_heading"],
  [data-pdf-toc="true"] strong,
  table thead th,
  .MuiTableCell-head {
    font-weight: 700 !important;
    text-transform: uppercase !important;
  }

  [class*="summary_subheading"],
  [class*="sub_sub_heading"],
  [class*="conclusionParagraph"],
  [class*="table_value"],
  table tbody td,
  .MuiTableCell-body {
    font-weight: 400 !important;
  }
  /* Bold subsection headings within the three ESG metric sections. */
  [class*="environment_section"] [class*="heading"],
  [class*="environment_section"] [class*="Heading"],
  [class*="social_section"] [class*="heading"],
  [class*="social_section"] [class*="Heading"],
  [class*="governance_section"] [class*="heading"],
  [class*="governance_section"] [class*="Heading"] {
    font-weight: 700 !important;
  }
  /* Left-align the three value columns in downloaded MIS tables. */
  table th:not(:first-child),
  table td:not(:first-child),
  .MuiTableCell-head:not(:first-child),
  .MuiTableCell-body:not(:first-child) {
    text-align: left !important;
  }
  /* Match downloaded section and table colors to the on-screen preview. */
  [class*="environment_heading"] {
    color: #4a8a5d !important;
  }

  [class*="social_heading"] {
    color: #ef7d00 !important;
  }

  [class*="governance_heading"] {
    color: #1c486b !important;
  }

  [class*="environment_section"] table thead,
  [class*="environment_section"] table thead tr,
  [class*="environment_section"] table thead th,
  [class*="environment_section"] .MuiTableHead-root,
  [class*="environment_section"] .MuiTableCell-head {
    background: #488257 !important;
    background-color: #488257 !important;
    color: #ffffff !important;
  }

  [class*="social_section"] table thead,
  [class*="social_section"] table thead tr,
  [class*="social_section"] table thead th,
  [class*="social_section"] .MuiTableHead-root,
  [class*="social_section"] .MuiTableCell-head {
    background: #ef7d00 !important;
    background-color: #ef7d00 !important;
    color: #ffffff !important;
  }

  [class*="governance_section"] table thead,
  [class*="governance_section"] table thead tr,
  [class*="governance_section"] table thead th,
  [class*="governance_section"] .MuiTableHead-root,
  [class*="governance_section"] .MuiTableCell-head {
    background: #1c486b !important;
    background-color: #1c486b !important;
    color: #ffffff !important;
  }
`;
export function getGhgReportPdfStyles() {
  return `
    ${GHG_REPORT_LEGACY_PDF_CSS}
    ${GHG_REPORT_COVER_PDF_CSS}
    ${GHG_REPORT_PDF_PAGE_BREAKS}
    ${GHG_REPORT_PREVIEW_PALETTE_PDF_CSS}
  `;
}